import {Strings} from "@app/constants/strings";
import {ContentDisplayModel, ContentTemplateModel, ContentThemeModel} from "@contents/models/contentsModel";

export type EnumTypeObject<T extends (string | undefined), I extends object> = {
    [_ in Exclude<T, undefined>]: I
}

export type EnumType<T extends string> = {
    [_ in T]: T
}

export type EnumTypeString<T extends (string | undefined)> = {
    [_ in Exclude<T, undefined>]: string
}

export type _LOGIN_TYPE = 'KRAFTON' | 'ADMIN';
export const LOGIN_TYPE: EnumType<_LOGIN_TYPE> = {
    KRAFTON: 'KRAFTON',
    ADMIN: 'ADMIN'
}

export type _SYSTEM_TYPE = 'SPACE' | 'BRAND' | 'SHOP';
export type _OPERATION_TYPE = 'OP' | 'BRAND' | 'CAFE' | 'DINING';
export const SpaceType: EnumType<_OPERATION_TYPE> = {
    OP: 'OP',
    BRAND: 'BRAND',
    CAFE: 'CAFE',
    DINING: 'DINING'
}

export type _PageTitleType = 'TITLE' | 'BACK';
export const PageTitleType: EnumType<_PageTitleType> = {
    TITLE: 'TITLE', // 페이지 타이틀 모드
    BACK: 'BACK'    // 뒤로가기 버튼이 있는 모드
}

export const RowPerPageSize = [50, 100, 150, 200]
export const RowPerPageSizeBig = [50, 100, 150, 200, 500]

export type _POLL_TYPE = 'single' | 'duplicate' | 'short' | 'long' | 'date' | 'grid' | 'grid_multi';

export type _WELFARE_TYPE = 'point' | 'coupon' | 'stamp' | 'prepaid' | 'poll' | 'board' | 'satisfaction';
export type _AD_DISPLAY_TYPE = 'app' | 'cms' | 'orderKiosk' | 'pos';
export type _SHOP_OPTION_TYPE = 'reservation' | 'pg';
export type _SHOP_TYPE = 'cafe' | 'dining';
export type _PAY_METHOD_TYPE = 'idCard' | 'common' | 'point' | 'coupon' | 'stamp' | 'prePay';
export type _DEVICE_TYPE = 'orderKiosk' | 'pickupBoard' | 'menuBoard' | 'wayFinding' | 'ticket' | 'satisfaction';
export type _MANUAL_TYPE = 'cafe' | 'dining' | 'service';
export type _CUSTOMER_STATE_TYPE = 0 | 1 | 2; // 재직, 휴직, 퇴사
export const CUSTOMER_STATE_TYPE_LIST: _CUSTOMER_STATE_TYPE[] = [0, 1, 2]
export type CUSTOMER_TYPE = 'internal' | 'external'; // 임직원, 외부인원
export const CUSTOMER_TYPE_LIST: EnumTypeString<CUSTOMER_TYPE> = {
    internal: '임직원',
    external: '외부인원',
}

export type _DEVICE_CONTENT_DINING_DISPLAY_TYPE = 'ONE' | 'MULTI';

export const DEVICE_CONTENT_DINING_DISPLAY_TYPE: EnumTypeString<_DEVICE_CONTENT_DINING_DISPLAY_TYPE | undefined> = {
    ONE: Strings.deviceTypeOne,
    MULTI: Strings.deviceTypeMulti
}

export type _SERVER_SURVEY_TYPE = 'SINGLE' | 'MULTI' | 'LONGTEXT' | 'DATE' | 'SHORT' | 'GRID';
export type _SERVER_SHOP_TYPE = 'CAFE' | 'CAFETERIA';
export type _SERVER_STATISTICS_PERIOD_TYPE = 'WEEK' | 'MONTH';
export type _SERVER_WEEK_TYPE = 'MON' | 'TUE' | 'WED' | 'THU' | 'FRI' | 'SAT' | 'SUN';
export type _SERVER_NOTICE_TYPE = 'UPDATE' | 'ISSUE' | 'GENERAL' | 'OTHER'; // 업데이트, 장애, 일반, 기타, 해당없음

export const WeekType: _SERVER_WEEK_TYPE[] = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
export const SERVER_WEEK_TYPE: EnumTypeString<_SERVER_WEEK_TYPE> = {
    MON: '월',
    TUE: '화',
    WED: '수',
    THU: '목',
    FRI: '금',
    SAT: '토',
    SUN: '일'
}

export const SERVER_NOTICE_TYPE: EnumTypeString<_SERVER_NOTICE_TYPE> = {
    UPDATE: Strings.update,
    ISSUE: Strings.issueAlarm,
    GENERAL: Strings.generalNotice,
    OTHER: Strings.etc
}

export type _SERVER_STATUS_TYPE = 'C' | 'R' | 'U' | 'D'; // 생성, 읽기, 수정, 삭제
export type _SERVER_MANUAL_TYPE = 'CAFE' | 'CAFETERIA' | 'SERVICE' | 'ALL';
export const SERVER_MANUAL_TYPE: EnumTypeString<_SERVER_MANUAL_TYPE> = {
    ALL: Strings.allView,
    SERVICE: Strings.serviceIntro,
    CAFE: Strings.companyCafeteria,
    CAFETERIA: Strings.companyDinner,
}

export type _SERVER_PAYMENT_METHOD_TYPE = 'IDCARD' | 'NORMAL';
export const SERVER_PAYMENT_METHOD_TYPE: EnumTypeString<_SERVER_PAYMENT_METHOD_TYPE> = {
    IDCARD: Strings.inside,
    NORMAL: Strings.outside
}

export type _PAYMENT_NAME_TYPE = 'RFID' | 'APP' | 'PNT' | 'KAKAOPAYM' | 'KAKAOPAYC' | 'CARD';
export const PAYMENT_NAME_TYPE: EnumTypeString<_PAYMENT_NAME_TYPE> = {
    RFID: Strings.employeeIdCard,
    APP: Strings.employeeIdCard,
    PNT: Strings.point,
    KAKAOPAYM: Strings.kakaoPayMoney,
    KAKAOPAYC: Strings.kakaoPayCard,
    CARD: Strings.creditCard
}

export type _SERVER_OS_TYPE = 'WINDOWS' | 'ANDROID';
export type _SERVER_PLAYER_TYPE =
    'CAFE_ORD'
    | 'CAFE_POS'
    | 'CAFE_PIC'
    | 'CAFETERIA_ORD'
    | 'CAFETERIA_MNU'
    | 'CAFETERIA_WAY'
    | 'CAFETERIA_TIC'
    |
    'CAFETERIA_SAT';
export type _SERVER_DISPLAY_ROTATION_TYPE = 'HORIZONTAL' | 'VERTICAL';
export type _SERVER_TEMPLATE_TYPE =
    'CAFE_ORD_V_BASIC'
    | 'CAFE_ORD_V_CRAFTON'
    | 'CAFE_ORD_V_KAKAO'
    | 'CAFE_PIC_V_BASIC'
    | 'CAFE_PIC_V_CRAFTON'
    |
    'CAFE_PIC_V_KAKAO'
    | 'CAFE_PIC_H_BASIC'
    | 'CAFE_PIC_H_CRAFTON'
    | 'CAFE_PIC_H_KAKAO'
    | 'CAFE_PIC_LED'
    | 'CAFETERIA_ORD_ALL'
    |
    'CAFETERIA_ORD_FRONT'
    | 'CAFETERIA_MENU_H'
    | 'CAFETERIA_WAY_H'
    | 'CAFETERIA_TICKET_H'
    | 'CAFETERIA_SATIS_V';
export type _SERVER_DISPLAY_OPTION_TYPE =
    'VERTICAL_1080'
    | 'VERTICAL_2160'
    | 'VERTICAL_3240'
    | 'VERTICAL_4320'
    | 'VERTICAL_5400'
    |
    'HORIZONTAL_1920'
    | 'HORIZONTAL_3840'
    | 'HORIZONTAL_5760'
    | 'HORIZONTAL_7680'
    | 'HORIZONTAL_9600';
export type _SERVER_SCREEN_FILL_TYPE = 'FILL_SCREEN' | 'STRETCH_TO_FIT' | 'FIT_INTO_FRAME' | 'ORIGINAL_SIZE';
export type _SERVER_ANIMATION_EFFECT_TYPE =
    'NO_EFFECT'
    | 'SHOW_UP'
    | 'SLIDE_LEFT_TO_RIGHT'
    | 'RIGHT_TO_LEFT_SLIDE'
    | 'LITERAL5'
    |
    'SLIDE_FROM_BOTTOM_TO_TOP'
    | 'SLIDE_FROM_TOP_TO_BOTTOM';
export type _SERVER_DISPLAY_TRANSIT_TYPE = 'AUTO' | 'SCHEDULE';
export type _SERVER_THEME_TYPE =
    'CAFE_ORD_V_CRAFTON01'
    | 'CAFE_ORD_V_CRAFTON02'
    | 'CAFE_ORD_V_CRAFTON03'
    | 'CAFE_ORD_V_CRAFTON04'
    | 'CAFE_ORD_V_KAKAO01'
    |
    'CAFE_ORD_V_KAKAO02'
    | 'CAFE_ORD_V_KAKAO03'
    | 'CAFE_ORD_V_KAKAO04'
    | 'CAFE_PICK_V_CRAFTON01'
    | 'CAFE_PICK_V_CRAFTON02'
    | 'CAFE_PICK_V_CRAFTON03'
    |
    'CAFE_PICK_V_CRAFTON04'
    | 'CAFE_PICK_V_KAKAO01'
    | 'CAFE_PICK_V_KAKAO02'
    | 'CAFE_PICK_V_KAKAO03'
    | 'CAFE_PICK_V_KAKAO04'
    | 'CAFE_PICK_H_CRAFTON01'
    |
    'CAFE_PICK_H_CRAFTON02'
    | 'CAFE_PICK_H_CRAFTON03'
    | 'CAFE_PICK_H_CRAFTON04'
    | 'CAFE_PICK_H_KAKAO01'
    | 'CAFE_PICK_H_KAKAO02'
    | 'CAFE_PICK_H_KAKAO03'
    |
    'CAFE_PICK_H_KAKAO04'
    | 'CAFE_PIC_LED_BASIC01'
    | 'CAFETERIA_ORD_ALL_BASIC01'
    | 'CAFETERIA_ORD_FRONT_BASIC01'
    | 'CAFETERIA_MENU_H_BASIC01'
    |
    'CAFETERIA_WAY_H_BASIC01'
    | 'CAFETERIA_TICKET_H_BASIC01'
    | 'CAFETERIA_SATIS_V_BASIC01';
export type _SERVER_BOARD_DISPLAY_TYPE = 'PICKUP' | 'MENU';
export type _SERVER_FONT_SIZE_TYPE = 'NORMAL' | 'BIG';
export type _SERVER_TIME_FORMAT_TYPE = 'F01' | 'F02' | 'F03' | 'F04';
export type _SERVER_TERMS_TYPE = 'TERMS_AND_CONDITIONS' | 'PRIVACY_POLICY';
export type _SERVER_ROLE_TYPE = 'MASTER' | 'SUPER_OWNER' | 'SUPER' | 'MANAGER';
export const SERVER_ROLE_TYPE = {
    MASTER: 'MASTER',
    SUPER_OWNER: 'SUPER_OWNER',
    SUPER: 'SUPER',
    MANAGER: 'MANAGER'
} as const;
export type _SERVER_DISPLAY_TYPE = 'ONE' | 'MULTI';
export type _SERVER_CUSTOMER_DATA_TYPE = 'LOCAL' | 'SERVER';
export type _SERVER_MEAL_ORDER_STATUS_TYPE = 'PRE_ORDER' | 'PAY_FAIL' | 'ORDER_COMPLETE' | 'PAYMENT_CANCELLATION';
export type _SERVER_CAFE_ORDER_STATUS_TYPE =
    'PRE_ORDER'
    | 'WAITING_FOR_ORDER'
    | 'ORDER_RECEPTION'
    | 'WAITING_FOR_PICKUP'
    | 'ORDER_COMPLETE'
    | 'PAY_FAIL'
    |
    'WITHDRAW_ORDER'
    | 'PAYMENT_CANCELLATION';
export const SERVER_CAFE_ORDER_STATUS_TYPE = {
    PRE_ORDER: '주문등록',
    WAITING_FOR_ORDER: '주문대기',
    ORDER_RECEPTION: '주문접수',
    WAITING_FOR_PICKUP: '픽업대기',
    ORDER_COMPLETE: '주문완료',
    PAY_FAIL: '결제실패',
    WITHDRAW_ORDER: '주문취소',
    PAYMENT_CANCELLATION: '결제취소'
}
export const SERVER_CAFE_ORDER_STATUS_SEARCH_TYPE = {
    ORDER_COMPLETE: '주문완료',
    WITHDRAW_ORDER: '주문취소',
    PAYMENT_CANCELLATION: '결제취소'
}
export const SERVER_CAFE_ORDER_DEVICE_TYPE = {
    KIOSK: '주문키오스크',
    MOBILE: 'APP',
    POS: 'POS'
}

export const SERVER_DINING_ORDER_DEVICE_TYPE = {
    KIOSK: Strings.orderKiosk,
    MEAL_TICKET: Strings.ticketKiosk,
    CMS: Strings.excelManualSales,
}
export type _SERVER_PAY_TYPE = 'INTERNAL' | 'EXTERNAL' | 'ALL';
export type _SERVER_DEVICE_TYPE = 'KIOSK' | 'MOBILE';
export type _SERVER_ORDER_TYPE = 'AUTO' | 'MANUAL' | 'DIRECT_ENTRY';
export type _SERVER_GOODS_OPTION_TYPE = 'SUB' | 'CUSTOM' | 'SPECIAL';
export type _SERVER_CUSTOMER_STATE_TYPE = 'WORKING' | 'ON_LEAVE' | 'LEAVE'; // 재직, 휴직, 퇴사

export const SERVER_CUSTOMER_STATE_TYPE: EnumTypeString<_SERVER_CUSTOMER_STATE_TYPE> = {
    WORKING: Strings.employment,
    ON_LEAVE: Strings.leaveOfAbsence,
    LEAVE: Strings.resignation,
}

export type _SERVER_CUSTOMER_ISSUE_TYPE = 'ADMIN' | 'FIELD' | 'INOUT' | 'NONE';  // 관리자, 현장, QR_출입연동
export type _SERVER_SURVEY_PROGRESS_TYPE = 'WAITING' | 'ONGOING' | 'CLOSE';
export type _SERVER_LANGUAGE_TYPE = 'ko' | 'en';
export type _SERVER_REF_TYPE =
    'MANUAL_OPENING'
    | 'MANUAL_CLOSING'
    | 'AUTO_OPENING'
    | 'AUTO_CLOSING'
    | 'BREAK_TIME_ENDS'
    | 'BREAK_TIME_STARTS'
    | 'RESUME_ORDER'
    |
    'PAUSE_ORDER'
    | 'LAST_ORDER_OFF'
    | 'LAST_ORDER_ON'
    | 'CALCULATE';
export type _SERVER_REF_DINING_TYPE =
    'MANUAL_OPENING'
    | 'MANUAL_CLOSING'
    | 'AUTO_OPENING'
    | 'AUTO_CLOSING'
    | 'CALCULATE';
export const SERVER_REF_TYPE: EnumTypeString<_SERVER_REF_TYPE> = {
    MANUAL_OPENING: '수동개점',
    MANUAL_CLOSING: '수동마감',
    AUTO_OPENING: '자동개점',
    AUTO_CLOSING: '자동마감',
    BREAK_TIME_ENDS: '브레이크 타임 종료',
    BREAK_TIME_STARTS: '브레이크 타임 시작',
    RESUME_ORDER: '주문일시정지 종료',
    PAUSE_ORDER: '주문일시정지 시작',
    LAST_ORDER_OFF: '라스트오더 종료',
    LAST_ORDER_ON: '라스트오더 시작',
    CALCULATE: '정산'
}
export const SERVER_REF_DINING_TYPE: EnumTypeString<_SERVER_REF_DINING_TYPE> = {
    //V2 매출관리 > 영업통계에서 사용 중
    MANUAL_OPENING: '수동개점',
    MANUAL_CLOSING: '수동마감',
    AUTO_OPENING: '자동개점',
    AUTO_CLOSING: '자동마감',
    CALCULATE: '정산'
}
export type _SERVER_SATISFACTION_TYPE = 'GOOD' | 'NORMAL' | 'BAD';
export type _SERVER_GOODS_ORDER_TYPE = 'SHOP_PICKUP' | 'RESERVATION_PICKUP' | 'RESERVATION_DELIVERY' | 'ROBOT_DELIVERY';
export const SERVER_GOODS_ORDER_TYPE: EnumTypeString<_SERVER_GOODS_ORDER_TYPE> = {
    SHOP_PICKUP: '매장픽업',
    RESERVATION_PICKUP: '예약픽업',
    RESERVATION_DELIVERY: '예약배달',
    ROBOT_DELIVERY: '로봇배달'
}
export type _SERVER_PAYMENT_STATUS_TYPE = 'PAID' | 'CANCEL' | 'REFUND';
export type _SERVER_LABEL_OPTION_TYPE = 'NONE' | 'NEW' | 'LIKE' | 'BEST' | 'SEASON';
export type _SERVER_SOURCE_TYPE = 'DATA' | 'EXCEL';
export type _SERVER_GOODS_STOCK_SAVE_TYPE = 'RECEIPT' | 'DAMAGE' | 'OTHER' | 'RESET';
export type _SERVER_GOODS_STOCK_RESET_TYPE = 'NONE' | 'DAILY' | 'MONTHLY' | 'PER_YEAR';
export type _SERVER_MANUAL_ENTRY_ORDER_STATUS_TYPE = 'READY' | 'CHECKED' | 'COMPLETE' | 'ALL';
export type _SERVER_CONGESTION_TYPE = 'SMOOTH' | 'NORMAL' | 'CROWDED';

export type _ENUM_TYPE_CLASS =
    'MemberRolesType'
    | 'OrderType'
    | 'PlayerType'
    | 'DisplayRotationType'
    | 'DirCreateType'
    | 'PayMethodType'
    |
    'SatisfactionType'
    | 'AuthType'
    | 'RegisterType'
    | 'GoodsOrderType'
    | 'fileType'
    | 'ScreenFillType'
    | 'PayStatusType'
    | 'OrderDeviceType'
    |
    'SurveyProgressType'
    | 'DisplayOptionType'
    | 'FontSizeType'
    | 'PushType'
    | 'DisplayType'
    | 'PeriodType'
    | 'ThemeType'
    | 'ManualType'
    |
    'WordType'
    | 'CustomerStateType'
    | 'ResetCycleType'
    | 'UserType'
    | 'PayType'
    | 'ManualEntryOrderStatusType'
    | 'GoodsOrderStatusType'
    |
    'AlarmType'
    | 'TemplateType'
    | 'CRUDActionType'
    | 'TermsType'
    | 'SurveyType'
    | 'TimeFormatType'
    | 'NoticeType'
    | 'SourceType'
    | 'dayOfTheWeek'
    |
    'actionRefType'
    | 'CongestionType'
    | 'BoardDisplayType'
    | 'GoodsStockSaveType'
    | 'OsType'
    | 'LabelOptionType'
    | 'RobotDeliveryStatusType'
    |
    'webService'
    | 'JwtTokenType'
    | 'GoodsOptionType'
    | 'DisplayTransitType'
    | 'DeployMethodType'
    | 'UserIssueType'
    | 'ShopType'
    | 'CustomerDataType'
    | 'ActionRefType';

export const SERVER_PLAYER_TYPE: EnumTypeString<_SERVER_PLAYER_TYPE> = {
    CAFE_ORD: "카페 오더 키오스크",
    CAFE_POS: "카페 포스",
    CAFE_PIC: "카페 픽업 보드",
    CAFETERIA_ORD: "식당 주문 키오스크",
    CAFETERIA_MNU: "식당 메뉴보드",
    CAFETERIA_WAY: "식당 웨이파인딩",
    CAFETERIA_TIC: "식당 식권 발급 키오스크",
    CAFETERIA_SAT: "식당 만족도 조사 키오스크"
}

export const CAFE_SERVER_PLAYER_TYPE = {
    CAFE_ORD: SERVER_PLAYER_TYPE.CAFE_ORD,
    CAFE_PIC: SERVER_PLAYER_TYPE.CAFE_PIC,
    CAFE_POS: SERVER_PLAYER_TYPE.CAFE_POS
}

export const CAFETERIA_SERVER_PLAYER_TYPE = {
    CAFETERIA_ORD: SERVER_PLAYER_TYPE.CAFETERIA_ORD,
    CAFETERIA_MNU: SERVER_PLAYER_TYPE.CAFETERIA_MNU,
    CAFETERIA_WAY: SERVER_PLAYER_TYPE.CAFETERIA_WAY,
    CAFETERIA_TIC: SERVER_PLAYER_TYPE.CAFETERIA_TIC,
    CAFETERIA_SAT: SERVER_PLAYER_TYPE.CAFETERIA_SAT
}

export const SERVER_TEMPLATE_TYPE: EnumTypeString<_SERVER_TEMPLATE_TYPE | undefined> = {
    CAFE_ORD_V_BASIC: "카페_주문_세로(1080x1920), 기본테마",
    CAFE_ORD_V_CRAFTON: "카페_주문_세로(1080x1920), 크레프톤 테마4종",
    CAFE_ORD_V_KAKAO: "카페_주문_세로(1080x1920), 카카오 테마4종",
    CAFE_PIC_V_BASIC: "카페_픽업_세로(1080x1920), 기본테마",
    CAFE_PIC_V_CRAFTON: "카페_픽업_세로(1080x1920), 크레프톤 테마4종",
    CAFE_PIC_V_KAKAO: "카페_픽업_세로(1080x1920), 카카오 테마4종",
    CAFE_PIC_H_BASIC: "카페_픽업_가로(1920x1080), 기본테마",
    CAFE_PIC_H_CRAFTON: "카페_픽업_가로(1920x1080), 크레프톤 테마4종",
    CAFE_PIC_H_KAKAO: "카페_픽업_가로(1920x1080), 카카오 테마4종",
    CAFE_PIC_LED: "카페_픽업_LED(1344x32)",
    CAFETERIA_ORD_ALL: "식당_주문_전후면 일체형(1280x1280)",
    CAFETERIA_ORD_FRONT: "식당_주문_전면(1080x1920)",
    CAFETERIA_MENU_H: "식당_메뉴_세로2k(2160x1920)",
    CAFETERIA_WAY_H: "식당_길찾기_세로(1080x1920)",
    CAFETERIA_TICKET_H: "식당_식권_세로(1080x1920)",
    CAFETERIA_SATIS_V: "식당_만족도_가로(1920x1080)",
}

// export const SERVER_THEME_TYPE: EnumTypeString<_SERVER_THEME_TYPE> = {
//   CAFE_ORD_V_CRAFTON01: "KRAFRON",
//   CAFE_ORD_V_CRAFTON02: "PUBG STUDIO",
//   CAFE_ORD_V_CRAFTON03: "BLUHOLE STUDIO",
//   CAFE_ORD_V_CRAFTON04: "구) KRAFTON",
//   CAFE_ORD_V_KAKAO01: "테마1 (YELLOW)",
//   CAFE_ORD_V_KAKAO02: "테마2 (GREEN)",
//   CAFE_ORD_V_KAKAO03: "테마2 (BLUE)",
//   CAFE_ORD_V_KAKAO04: "테마2 (PINK)",
//   CAFE_PICK_V_CRAFTON01: "KRAFTON",
//   CAFE_PICK_V_CRAFTON02: "PUBG STUDIO",
//   CAFE_PICK_V_CRAFTON03: "BLUHOLE STUDIO",
//   CAFE_PICK_V_CRAFTON04: "구) KRAFTON",
//   CAFE_PICK_V_KAKAO01: "테마1 (YELLOW)",
//   CAFE_PICK_V_KAKAO02: "테마2 (GREEN)",
//   CAFE_PICK_V_KAKAO03: "테마2 (BLUE)",
//   CAFE_PICK_V_KAKAO04: "테마2 (PINK)",
//   CAFE_PICK_H_CRAFTON01: "KRAFTON",
//   CAFE_PICK_H_CRAFTON02: "PUBG STUDIO",
//   CAFE_PICK_H_CRAFTON03: "BLUHOLE STUDIO",
//   CAFE_PICK_H_CRAFTON04: "구) KRAFTON",
//   CAFE_PICK_H_KAKAO01: "테마1 (YELLOW)",
//   CAFE_PICK_H_KAKAO02: "테마2 (GREEN)",
//   CAFE_PICK_H_KAKAO03: "테마2 (BLUE)",
//   CAFE_PICK_H_KAKAO04: "테마2 (PINK)",
// }
export const SERVER_DISPLAY_OPTION_TYPE: EnumTypeString<_SERVER_DISPLAY_OPTION_TYPE> = {
    VERTICAL_1080: "1장(1080 X 1920)",
    VERTICAL_2160: "2장(2160 X 1920)",
    VERTICAL_3240: "3장(3240 X 1920)",
    VERTICAL_4320: "4장(4320 X 1920)",
    VERTICAL_5400: "5장(5400 X 1920)",
    HORIZONTAL_1920: "1장(1920 X 1080)",
    HORIZONTAL_3840: "2장(3840 X 1080)",
    HORIZONTAL_5760: "3장(5760 X 1080)",
    HORIZONTAL_7680: "4장(7680 X 1080)",
    HORIZONTAL_9600: "5장(9600 X 1080)",
}

export const SERVER_DISPLAY_OPTION_VERTICAL_TYPE = {
    VERTICAL_1080: "1장(1080 X 1920)",
    VERTICAL_2160: "2장(2160 X 1920)",
    VERTICAL_3240: "3장(3240 X 1920)",
    VERTICAL_4320: "4장(4320 X 1920)",
    VERTICAL_5400: "5장(5400 X 1920)"
}

export const SERVER_DISPLAY_OPTION_HORIZONTAL_TYPE = {
    HORIZONTAL_1920: "1장(1920 X 1080)",
    HORIZONTAL_3840: "2장(3840 X 1080)",
    HORIZONTAL_5760: "3장(5760 X 1080)",
    HORIZONTAL_7680: "4장(7680 X 1080)",
    HORIZONTAL_9600: "5장(9600 X 1080)",
}

export const DATE_FORMAT_DOT = "YYYY.MM.DD";
export const DATE_FORMAT_DASH = "YYYY-MM-DD";
export const MONTH_FORMAT_DASH = "YYYY-MM";
export const MONTH_FORMAT_DOT = "YYYY.MM";
export const TIME_SEC_FORMAT = "HH:mm:ss";
export const TIME_MIN_FORMAT = "HH:mm";
export const TIME_MIN_AMPM_FORMAT = "A hh:mm";
export const DATE_TIME_MIN_FORMAT = "YYYY-MM-DD HH:mm";
export const DATE_TIME_SEC_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const DATE_TIME_MIN_AMPM_FORMAT = "YYYY-MM-DD A hh:mm";

export type PICKUP_TYPE = 'STORE' | 'RESERVE_PICKUP' | 'RESERVE_DELIVERY' | 'ROBOT';

export type STATISTICS_SALES_GRAPH_TYPE = 'CAFE_ORDER_DEVICE_TYPE' | 'DINING_ORDER_DEVICE_TYPE' | 'PICKUP_TYPE' | 'PAID_METHOD';
export const SERVER_STATISTICS_PERIOD_TYPE: EnumTypeString<_SERVER_STATISTICS_PERIOD_TYPE> = {
    MONTH: Strings.monthly,
    WEEK: Strings.weekly
}

export const SERVER_MANUAL_ENTRY_ORDER_STATUS_TYPE: EnumTypeString<_SERVER_MANUAL_ENTRY_ORDER_STATUS_TYPE> = {
    READY: '서버매칭대기',
    CHECKED: '정산대기',
    COMPLETE: '정산완료',
    ALL: '전체'
}

export type DINING_MANUAL_ORDER_STATUS_TYPE = 'READY' | 'CHECKED' | 'COMPLETE';

export type BOOLEAN_TYPE_SELECT = 'ALL' | 'ON' | 'OFF';
export type DEVICE_COMMAND_TYPE = 'START' | 'SHUTDOWN' | 'STOP' | 'REBOOT' | 'UPDATE';

export const CONTENT_TEMPLATE_SET_TYPE: EnumTypeObject<_SERVER_TEMPLATE_TYPE, ContentTemplateModel[]> = {
    CAFE_ORD_V_BASIC: [{section: 'A', width: '362px', height: '580px'}],
    CAFE_ORD_V_CRAFTON: [{section: 'A', width: '362px', height: '580px'}],
    CAFE_ORD_V_KAKAO: [{section: 'A', width: '362px', height: '580px'}],

    CAFE_PIC_V_BASIC: [{section: 'A', width: '326px', height: '580px'}, {
        section: 'B',
        width: '326px',
        height: '580px'
    }, {section: 'C', height: '550px'}, {section: 'D', height: '412px'}, {section: 'E', height: '330px'},],
    CAFE_PIC_V_CRAFTON: [{section: 'A', width: '326px', height: '580px'}, {
        section: 'B',
        width: '326px',
        height: '580px'
    }, {section: 'C', height: '550px'}, {section: 'D', height: '412px'}, {section: 'E', height: '330px'},],
    CAFE_PIC_V_KAKAO: [{section: 'A', width: '326px', height: '580px'}, {
        section: 'B',
        width: '326px',
        height: '580px'
    }, {section: 'C', height: '550px'}, {section: 'D', height: '412px'}, {section: 'E', height: '330px'},],

    CAFE_PIC_H_BASIC: [{section: 'A', height: '521px'}, {section: 'B', height: '260px'}, {
        section: 'C',
        height: '173px'
    }, {section: 'D', height: '130px'}, {section: 'E', height: '104px'},],
    CAFE_PIC_H_CRAFTON: [{section: 'A', height: '521px'}, {section: 'B', height: '260px'}, {
        section: 'C',
        height: '173px'
    }, {section: 'D', height: '130px'}, {section: 'E', height: '104px'},],
    CAFE_PIC_H_KAKAO: [{section: 'A', height: '521px'}, {section: 'B', height: '260px'}, {
        section: 'C',
        height: '173px'
    }, {section: 'D', height: '130px'}, {section: 'E', height: '104px'},],

    CAFE_PIC_LED: [{section: 'A', width: '100%', height: '50px'}],

    CAFETERIA_ORD_ALL: [{section: 'A', width: '362px', height: '580px'}, {
        section: 'B',
        width: '174px',
        height: '289px'
    }],
    CAFETERIA_ORD_FRONT: [{section: 'A', width: '362px', height: '580px'}],
    CAFETERIA_MENU_H: [{section: 'A', width: '326px', height: '580px'}, {
        section: 'B',
        width: '326px',
        height: '580px'
    }],
    CAFETERIA_WAY_H: [{section: 'A', width: '326px', height: '580px'}],

    CAFETERIA_TICKET_H: [{section: 'A', width: '362px', height: '580px'}],

    CAFETERIA_SATIS_V: [{section: 'A', width: '100%', height: '521px'}]
}

export type _CONTENT_CONTROL_TAB_LIST = "fileAdd" | "contentsOption" | "contentsTime" | "contentsCourse";
// export const SERVER_THEME_COLOR_TYPE: EnumTypeString<_SERVER_THEME_TYPE> = {
//   CAFE_ORD_V_CRAFTON01: "KRAFRON",
//   CAFE_ORD_V_CRAFTON02: "PUBG STUDIO",
//   CAFE_ORD_V_CRAFTON03: "BLUHOLE STUDIO",
//   CAFE_ORD_V_CRAFTON04: "구) KRAFTON",
//   CAFE_ORD_V_KAKAO01: "테마1 (YELLOW)",
//   CAFE_ORD_V_KAKAO02: "테마2 (GREEN)",
//   CAFE_ORD_V_KAKAO03: "테마2 (BLUE)",
//   CAFE_ORD_V_KAKAO04: "테마2 (PINK)",
//   CAFE_PICK_V_CRAFTON01: "KRAFTON",
//   CAFE_PICK_V_CRAFTON02: "PUBG STUDIO",
//   CAFE_PICK_V_CRAFTON03: "BLUHOLE STUDIO",
//   CAFE_PICK_V_CRAFTON04: "구) KRAFTON",
//   CAFE_PICK_V_KAKAO01: "테마1 (YELLOW)",
//   CAFE_PICK_V_KAKAO02: "테마2 (GREEN)",
//   CAFE_PICK_V_KAKAO03: "테마2 (BLUE)",
//   CAFE_PICK_V_KAKAO04: "테마2 (PINK)",
//   CAFE_PICK_H_CRAFTON01: "KRAFTON",
//   CAFE_PICK_H_CRAFTON02: "PUBG STUDIO",
//   CAFE_PICK_H_CRAFTON03: "BLUHOLE STUDIO",
//   CAFE_PICK_H_CRAFTON04: "구) KRAFTON",
//   CAFE_PICK_H_KAKAO01: "테마1 (YELLOW)",
//   CAFE_PICK_H_KAKAO02: "테마2 (GREEN)",
//   CAFE_PICK_H_KAKAO03: "테마2 (BLUE)",
//   CAFE_PICK_H_KAKAO04: "테마2 (PINK)",
// }

export const CONTENT_DISPLAY_COUNT_TYPE: EnumTypeObject<_SERVER_DISPLAY_OPTION_TYPE | undefined, ContentDisplayModel> = {
    VERTICAL_1080: {type: 'VERTICAL', displayCount: 1},
    VERTICAL_2160: {type: 'VERTICAL', displayCount: 2},
    VERTICAL_3240: {type: 'VERTICAL', displayCount: 3},
    VERTICAL_4320: {type: 'VERTICAL', displayCount: 4},
    VERTICAL_5400: {type: 'VERTICAL', displayCount: 5},
    HORIZONTAL_1920: {type: 'HORIZONTAL', displayCount: 1},
    HORIZONTAL_3840: {type: 'HORIZONTAL', displayCount: 2},
    HORIZONTAL_5760: {type: 'HORIZONTAL', displayCount: 3},
    HORIZONTAL_7680: {type: 'HORIZONTAL', displayCount: 4},
    HORIZONTAL_9600: {type: 'HORIZONTAL', displayCount: 5},
}

export const SERVER_SCREEN_FILL_TYPE: EnumTypeString<_SERVER_SCREEN_FILL_TYPE> = {
    FILL_SCREEN: Strings.fit.cover,
    STRETCH_TO_FIT: Strings.fit.fill,
    FIT_INTO_FRAME: Strings.fit.contain,
    ORIGINAL_SIZE: Strings.fit.none,
}

export const SERVER_ANIMATION_EFFECT_TYPE: EnumTypeString<_SERVER_ANIMATION_EFFECT_TYPE> = {
    NO_EFFECT: Strings.animation.none,
    SHOW_UP: Strings.animation.appear,
    SLIDE_LEFT_TO_RIGHT: Strings.animation.leftToRight,
    RIGHT_TO_LEFT_SLIDE: Strings.animation.rightToLeft,
    SLIDE_FROM_BOTTOM_TO_TOP: Strings.animation.bottomToTop,
    SLIDE_FROM_TOP_TO_BOTTOM: Strings.animation.topToBottom,
    LITERAL5: ''
}

export const CONTENT_THEME_COLOR_TYPE: EnumTypeObject<_SERVER_THEME_TYPE | undefined, ContentThemeModel> = {
    CAFE_ORD_V_CRAFTON01: {font: "#1C1F28", background: "#3E3E3E"},
    CAFE_ORD_V_CRAFTON02: {font: "#FFB60F", background: "#FFB60F"},
    CAFE_ORD_V_CRAFTON03: {font: "#1E82FF", background: "#348FFF"},
    CAFE_ORD_V_CRAFTON04: {font: "#1C1F28", background: "#1C1F28"},
    CAFE_ORD_V_KAKAO01: {font: "#FFCD00", background: "#FFE24C"},
    CAFE_ORD_V_KAKAO02: {font: "#7EC93C", background: "#A4F5BA"},
    CAFE_ORD_V_KAKAO03: {font: "#50B5FF", background: "#8CCFFF"},
    CAFE_ORD_V_KAKAO04: {font: "#E39797", background: "#F3BABA"},
    CAFE_PICK_V_CRAFTON01: {font: "", background: ""},
    CAFE_PICK_V_CRAFTON02: {font: "", background: ""},
    CAFE_PICK_V_CRAFTON03: {font: "", background: ""},
    CAFE_PICK_V_CRAFTON04: {font: "", background: ""},
    CAFE_PICK_V_KAKAO01: {font: "", background: ""},
    CAFE_PICK_V_KAKAO02: {font: "", background: ""},
    CAFE_PICK_V_KAKAO03: {font: "", background: ""},
    CAFE_PICK_V_KAKAO04: {font: "", background: ""},
    CAFE_PICK_H_CRAFTON01: {font: "", background: ""},
    CAFE_PICK_H_CRAFTON02: {font: "", background: ""},
    CAFE_PICK_H_CRAFTON03: {font: "", background: ""},
    CAFE_PICK_H_CRAFTON04: {font: "", background: ""},
    CAFE_PICK_H_KAKAO01: {font: "", background: ""},
    CAFE_PICK_H_KAKAO02: {font: "", background: ""},
    CAFE_PICK_H_KAKAO03: {font: "", background: ""},
    CAFE_PICK_H_KAKAO04: {font: "", background: ""},
    CAFE_PIC_LED_BASIC01: {font: "", background: ""},
    CAFETERIA_ORD_ALL_BASIC01: {font: "", background: ""},
    CAFETERIA_ORD_FRONT_BASIC01: {font: "", background: ""},
    CAFETERIA_MENU_H_BASIC01: {font: "", background: ""},
    CAFETERIA_WAY_H_BASIC01: {font: "", background: ""},
    CAFETERIA_TICKET_H_BASIC01: {font: "#000000", background: ""},
    CAFETERIA_SATIS_V_BASIC01: {font: "", background: ""},
}

export type _UPLOAD_STATE_TYPE = 'IDLE' | 'UPLOADING' | 'ERROR' | 'SUCCESS';
export type _UPLOAD_BASE_TYPE = 'agent' | 'notice' | 'manual' | 'base';


export const SERVER_CONGESTION_TYPE: EnumTypeString<_SERVER_CONGESTION_TYPE> = {
    SMOOTH: Strings.spare,
    NORMAL: Strings.commonly,
    CROWDED: Strings.confusion
}

export type _SERVER_FILE_TYPE = 'ALL' | 'IMG' | 'DOC' | 'MOV' | 'APP' | 'SW';

export const TRANSITION = {
    none: {
        from: {opacity: 1},
        enter: {opacity: 1},
        leave: {opacity: 1},
    },
    changeOpacity: {
        from: {opacity: 0},
        enter: {opacity: 1},
        leave: {opacity: 0},
    },
    rightToLeft: {
        from: {transform: 'translate3d(100%,0,0)'},
        enter: {transform: 'translate3d(0,0,0)'},
        leave: {transform: 'translate3d(-100%,0,0)'},
    },
    leftToRight: {
        from: {transform: 'translate3d(-100%,0,0)'},
        enter: {transform: 'translate3d(0,0,0)'},
        leave: {transform: 'translate3d(100%,0,0)'},
    },
    bottomToTop: {
        from: {transform: 'translate3d(0,100%,0)'},
        enter: {transform: 'translate3d(0,0,0)'},
        leave: {transform: 'translate3d(0,-100%,0)'},
    },
    topToBottom: {
        from: {transform: 'translate3d(0,-100%,0)'},
        enter: {transform: 'translate3d(0,0,0)'},
        leave: {transform: 'translate3d(0,100%,0)'},
    },
    scaleUp: {
        from: {transform: 'scale(0,0)'},
        enter: {transform: 'scale(1,1)'},
        leave: {transform: 'scale(1,1)'},
    },
    rotateX: {
        from: {transform: 'rotateX(180deg)'},
        enter: {transform: 'rotateX(0deg)'},
        leave: {transform: 'rotateX(180deg)'},
    },
    rotateY: {
        from: {transform: 'rotateY(180deg)'},
        enter: {transform: 'rotateY(0deg)'},
        leave: {transform: 'rotateY(180deg)'},
    },
    skew: {
        from: {transform: 'skew(90deg,90deg)'},
        enter: {transform: 'skew(0deg, 0deg)'},
        leave: {transform: 'skew(90deg,90deg)'},
    }
};

export type BRAND_REGISTERED_TYPE = 'API' | 'EXCEL' | 'EXTERNAL' | 'TEMPORARY';


export type STATISTICS_SEARCH_TYPE = 'DAY' | 'DURATION';
export const STATISTICS_SEARCH_TYPE_ENUM: EnumTypeString<STATISTICS_SEARCH_TYPE> = {
    DAY: Strings.businessDate,
    DURATION: Strings.searchPeriod
}

export type STATISTICS_DURATION_TYPE = 'DAY' | 'MONTH' | 'PERIOD';
export const STATISTICS_DURATION_TYPE_ENUM: EnumTypeString<STATISTICS_DURATION_TYPE> = {
    DAY: Strings.durationDay,
    MONTH: Strings.durationMonth,
    PERIOD: Strings.durationPeriod
}

export type STATISTICS_CALENDAR_SEARCH_TYPE = 'KIOSK' | 'MOBILE' | 'MEAL_TICKET' | 'CMS' | 'POS';
export type STATISTICS_SEARCH_AGO_TYPE = 'month' | 'week' | 'period';
export type CALENDAR_VIEW_TYPE = 'SALES' | 'OPERATION';

export const STATISTICS_CAFE_CALENDAR_SEARCH = [
    {key: "ALL", value: Strings.terminalAll},
    {key: "KIOSK", value: Strings.orderKiosk},
    {key: "MOBILE", value: Strings.app},
    {key: "POS", value: Strings.pos},
]

export const STATISTICS_DINING_CALENDAR_SEARCH = [
    {key: "ALL", value: Strings.terminalAll},
    {key: "KIOSK", value: Strings.orderKiosk},
    {key: "MEAL_TICKET", value: Strings.ticketKiosk},
    {key: "CMS", value: Strings.excelManualSales},
]

export const STATISTICS_TIME_SEARCH = [
    {key: '5', value: '5분 간격'},
    {key: '10', value: '10분 간격'},
    {key: '20', value: '20분 간격'},
    {key: '30', value: '30분 간격'},
]

export type STATISTICS_SEARCH_GRAPH_TYPE = 'SALES' | 'COUNT';
export const STATISTICS_SEARCH_GRAPH_TYPE_KEY_VALUE = [
    {key: 'SALES', value: Strings.totalSales},
    {key: 'COUNT', value: Strings.numberOfOrders},
]

export const STATISTICS_BUSINESS_SEARCH_GRAPH_TYPE_KEY_VALUE = [
    {key: 'SALES', value: Strings.totalSales},
    {key: 'COUNT', value: Strings.numberOfSales},
]

export const POINT_GIVE_PERIOD_SEARCH = [
    {key: 'MONTHLY', value: Strings.everyMonth},
    {key: 'QUARTERLY', value: Strings.quarterly},
    {key: 'SEMI_ANNUALLY', value: Strings.halfYearly},
    {key: 'ANNUALLY', value: Strings.everyYearly},
]

export type POINT_GIVE_PERIOD_TYPE = 'MONTHLY' | 'QUARTERLY' | 'SEMI_ANNUALLY' | 'ANNUALLY' | 'NONE';

export const POINT_GIVE_PERIOD: EnumTypeString<POINT_GIVE_PERIOD_TYPE> = {
    MONTHLY: Strings.everyMonth,
    QUARTERLY: Strings.quarterly,
    SEMI_ANNUALLY: Strings.halfYearly,
    ANNUALLY: Strings.everyYearly,
    NONE: ''
}

//2025.07.14 포인트: 지급 방식
export type _SERVER_REWARD_USAGE_TYPE =
    'EARN'
    | 'CHARGE_ITEM'
    | 'CHARGE_AUTO'
    | 'CHARGE_EXCEL'
    | 'USE'
    | 'EXPIRE'
    | 'REFUND'
    | 'PENDING'
    | 'TRANSFER'
    | 'RETRIEVE_ITEM'
    | 'RETRIEVE_EXCEL'
    | 'ANNUAL_EXPIRE'
    | 'ANNUAL_RENEWAL'
    | 'NONE';
export const SERVER_REWARD_USAGE_TYPE: EnumTypeString<_SERVER_REWARD_USAGE_TYPE> = {
    EARN: Strings.pointRewardEarn,
    CHARGE_ITEM: Strings.pointRewardChangeItem,
    CHARGE_AUTO: Strings.pointRewardChangeAuto,
    CHARGE_EXCEL: Strings.pointRewardChangeExcel,
    USE: Strings.pointRewardUse,
    EXPIRE: Strings.pointRewardExpire,
    REFUND: Strings.pointRewardRefund,
    PENDING: Strings.pointRewardPending,
    TRANSFER: Strings.pointRewardTransfer,
    RETRIEVE_ITEM: Strings.pointRewardRetrieveManual,
    RETRIEVE_EXCEL: Strings.pointRewardRetrieveExcel,
    ANNUAL_EXPIRE: Strings.pointRewardAnnualExpire,
    ANNUAL_RENEWAL: Strings.pointRewardAnnualRenewal,
    NONE: Strings.pointRewardNone,
}

export const SERVER_REWARD_USAGE_SEARCH = [
    {key: "EARN", value: Strings.pointRewardEarn},
    {key: "CHARGE_ITEM", value: Strings.pointRewardChangeItem},
    {key: "CHARGE_AUTO", value: Strings.pointRewardChangeAuto},
    {key: "CHARGE_EXCEL", value: Strings.pointRewardChangeExcel},
    {key: "USE", value: Strings.pointRewardUse},
    {key: "EXPIRE", value: Strings.pointRewardExpire},
    {key: "REFUND", value: Strings.pointRewardRefund},
    {key: "PENDING", value: Strings.pointRewardPending},
    {key: "TRANSFER", value: Strings.pointRewardTransfer},
    {key: "RETRIEVE_ITEM", value: Strings.pointRewardRetrieveManual},
    {key: "RETRIEVE_EXCEL", value: Strings.pointRewardRetrieveExcel},
    {key: "ANNUAL_EXPIRE", value: Strings.pointRewardAnnualExpire},
    {key: "ANNUAL_RENEWAL", value: Strings.pointRewardAnnualRenewal},
    {key: "NONE", value: Strings.pointRewardNone}
]

//2025.07.14 포인트: 리워드 검색 유형
export type _SERVER_REWARD_TYPE = 'EARN' | 'USE' | 'EXPIRE' | 'RETRIEVE';
export const SERVER_REWARD_TYPE: EnumTypeString<_SERVER_REWARD_TYPE> = {
    EARN: Strings.pointRewardEarn,
    USE: Strings.pointRewardUse,
    EXPIRE: Strings.pointRewardExpire,
    RETRIEVE: Strings.pointRewardRetrieve
}
export const SERVER_REWARD_SEARCH = [
    {key: "EARN", value: Strings.pointRewardEarn},
    {key: "USE", value: Strings.pointRewardUse},
    {key: "EXPIRE", value: Strings.pointRewardExpire},
    {key: "RETRIEVE", value: Strings.pointRewardRetrieve},
]

//2025.07.14 포인트: 리워드 등록 방법
export type _SERVER_REWARD_REGISTERED_TYPE = 'AUTO' | 'EXCEL' | 'MANUAL';
export const SERVER_REWARD_REGISTERED_TYPE: EnumTypeString<_SERVER_REWARD_REGISTERED_TYPE> = {
    AUTO: Strings.autoRegistered,
    EXCEL: Strings.excelRegistered,
    MANUAL: Strings.manualRegistered,
}
export const SERVER_REWARD_REGISTERED_SEARCH = [
    {key: "AUTO", value: Strings.autoRegistered},
    {key: "EXCEL", value: Strings.excelRegistered},
    {key: "MANUAL", value: Strings.manualRegistered}
]

// 2025.08.14 모바일 사원증 설정
export type _SERVER_MOBILE_CARD_TYPE = 'BARCODE' | 'QRCODE';

export const ROLE_TYPE_WEIGHT : EnumTypeString<_SERVER_ROLE_TYPE> = {
    MASTER : '4',
    SUPER_OWNER: '3',
    SUPER: '2',
    MANAGER: '1'
}

export type EMPLOYEE_EXCEL_COLUMN_TYPE = 'empNo' | 'rfid' | 'companyCd' | 'nameKo' | 'nameEn' | 'email' | 'customerStateType' | '';